import { render, staticRenderFns } from "./AccountLogout.vue?vue&type=template&id=000c0430&"
import script from "./AccountLogout.vue?vue&type=script&lang=js&"
export * from "./AccountLogout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports